import {
  IconButton, useToast, Tooltip
} from "@chakra-ui/react"
import { MdContentCopy } from "react-icons/md";

const CopyButton = ({ text }) => {
  const toast = useToast()

  function copyToClipboard() {
    navigator.clipboard.writeText(text).then(
      () => {
        if (toast) {
          toast({
            title: "Copied to clipboard",
            status: "success",
            duration: 2000,
            isClosable: true,
          })
        }
      },
      (err) => {
        console.error("Could not copy text: ", err)
        if (toast) {
          toast({
            title: "Failed to copy",
            status: "error",
            duration: 2000,
            isClosable: true,
          })
        }
      },
    )
  }

  return (
    <Tooltip shouldWrapChildren hasArrow  placement='top' label="Copy to clipboard">
      <IconButton
        aria-label="Copy"
        key={"ghost"}
        variant={"ghost"}
        rounded="full"
        onClick={copyToClipboard}
      >
        <MdContentCopy />
      </IconButton>
    </Tooltip>
  )
}

export default CopyButton